import {$http} from '@/utils/https'
import {STUDENTS_SET_ALL_LIST, STUDENTS_SET_LIST, SYUDENTS_REQUEST_STATUS} from './types/mutation-types';

import {FETCH_STUDENTS_LIST} from './types/action-types';


const state = {
    listStudents: [],
    listAllStudents: [],
    // Separate loading states for each widget
    isTopStudentsLoading: true,      // For top-students widget
    isAllStudentsLoading: true       // For all-students widget
};

const getters = {
    listStudents: state => state.listStudents,
    listAllStudents: state => state.listAllStudents,
    // Separate getters for each widget
    isTopStudentsLoading: state => state.isTopStudentsLoading,
    isAllStudentsLoading: state => state.isAllStudentsLoading,
    // Keep backward compatibility
    isListStudentsLoading: state => state.isTopStudentsLoading || state.isAllStudentsLoading,
};

const actions = {
    [FETCH_STUDENTS_LIST]: async ({commit}, payload) => {
        try {
            if (payload?.limit) {
                // Top students with limit
                commit('SET_TOP_STUDENTS_LOADING', true);

                const response = await $http.get(`${process.env.VUE_APP_ROOT_COURSE}courses/${payload.id}/widgets/best-students?limit=${payload.limit}`);

                commit(STUDENTS_SET_LIST, response.data.data);
                return response;
            } else {
                // All students without limit
                commit('SET_ALL_STUDENTS_LOADING', true);

                const response = await $http.get(`${process.env.VUE_APP_ROOT_COURSE}courses/${payload.id}/widgets/best-students`);

                commit(STUDENTS_SET_ALL_LIST, response.data.data);
                return response;
            }

        } catch (e) {
            throw e;
        } finally {
            // Set appropriate loading state to false
            if (payload?.limit) {
                commit('SET_TOP_STUDENTS_LOADING', false);
            } else {
                commit('SET_ALL_STUDENTS_LOADING', false);
            }
        }
    },
};

const mutations = {
    [STUDENTS_SET_LIST](state, list) {
        state.listStudents = list;
    },
    [STUDENTS_SET_ALL_LIST](state, list) {
        state.listAllStudents = list;
    },
    // New separate mutations for each widget
    SET_TOP_STUDENTS_LOADING(state, status) {
        state.isTopStudentsLoading = status;
    },
    SET_ALL_STUDENTS_LOADING(state, status) {
        state.isAllStudentsLoading = status;
    },
    // Keep old mutation for backward compatibility
    [SYUDENTS_REQUEST_STATUS](state, status) {
        state.isListStudentsLoading = status;
    }
};
export default {
    state,
    getters,
    actions,
    mutations,
};
